import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CreateAccountRoutingModule } from './create-account-routing.module';
import { CreateAccountComponent } from './create-account.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { VerifyAccountComponent } from './verify-account/verify-account.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { LogInComponent } from './log-in/log-in.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { LoginSectionComponent } from './log-in/login-section/login-section.component';
import { ResetPasswordComponent } from './log-in/reset-password/reset-password.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReferralComponent } from './referral/referral.component';
import { OtpVerificationComponent } from 'src/app/shared/otp-verification/otp-verification.component';

@NgModule({
  declarations: [
    CreateAccountComponent,
    VerifyAccountComponent,
    SignUpComponent,
    LogInComponent,
    LoginSectionComponent,
    ResetPasswordComponent,
    ReferralComponent,
    OtpVerificationComponent,
  ],
  imports: [
    CommonModule,
    CreateAccountRoutingModule,
    MatTooltipModule,
    MatCardModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    RouterModule,
    MatSnackBarModule,
    MatTabsModule,
    MatDividerModule,
    FormsModule
  ],
  providers: [
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {
        duration: 4000,
        verticalPosition: 'bottom',
        horizontalPosition: 'end',
      }
    }
  ]
})
export class CreateAccountModule { }
